import { Turbo } from "@hotwired/turbo-rails"

Turbo.config.drive.progressBarDelay = 1_000_000

import "./controllers"
